import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AsyncSelect from 'react-select/lib/Async';
import TELEMETRY_API from '../../../../../config/api';

export default class Endpoint extends Component {
  static propTypes = {
    setValue: PropTypes.func.isRequired,
    config: PropTypes.object.isRequired,
    value: PropTypes.array,
    field: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    customProps: PropTypes.object,
    url: PropTypes.string,
    typeahead: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = vals => {
    this.props.setValue(vals.map(el => el.value));
  };

  typeahead = search => {
    return this.props
      .typeahead(`${TELEMETRY_API}${this.props.url.replace('/api/', '')}`, {
        search,
        tenantId: '0ddb51b2-38b8-4153-9c90-ded384f83a88',
      })
      .then(result => {
        const options = [];
        if (result.payload && result.payload.data) {
          result.payload.data.forEach(item =>
            options.push({ value: item, label: item }),
          );
        }
        return options;
      });
  };

  getValue = () => {
    return this.props.value ? this.props.value.map(el => ({ value: el, label: el })) : [];
  }

  render() {
    return (
      <AsyncSelect
        {...this.props}
        value={this.getValue()}
        onChange={this.handleChange}
        loadOptions={this.typeahead}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/management/components/QueryBuilder/widgets/Endpoint.js